var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5212",
    "data-name": "Path 5212",
    d: "M146.458,42.382a1.222,1.222,0,0,0,1.728,0l4.609-4.609a1.222,1.222,0,0,0-1.728-1.728l-2.523,2.523V25.222a1.222,1.222,0,1,0-2.444,0V38.567l-2.523-2.523a1.222,1.222,0,1,0-1.728,1.728Z",
    transform: "translate(-111.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5213",
    "data-name": "Path 5213",
    d: "M46.759,232a1.232,1.232,0,0,0-1.241,1.222v9.37H26.483v-9.37a1.242,1.242,0,0,0-2.483,0V243a2.053,2.053,0,0,0,2.069,2.037H45.931A2.053,2.053,0,0,0,48,243v-9.777A1.232,1.232,0,0,0,46.759,232Z",
    transform: "translate(0 -197.036)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a0485be0bcc120135da89341487e8d73.svg";
export { ForwardRef as ReactComponent };